import React, { useCallback, useState } from 'react'
import { Container } from '@material-ui/core'
import { useCreationStyles } from './creation.styles'
import { moduleList } from './const'
import ModulesCards from './ModulesCards/ModulesCards.jsx'
import CreateModal from './CreateModal/CreateModal'

const CreationPanel = () => {
  const classes = useCreationStyles()
  const [isOpen, setIsOpen] = useState(false)
  const [module, setModule] = useState({})

  const handleOpen = useCallback(
    data => {
      setModule({ module: data.module, division: 'ShinhanX' })
      setIsOpen(true)
    },
    [setModule, setIsOpen]
  )

  return (
    <Container className={classes.root} fullWidth>
      <ModulesCards modules={moduleList} handleOpen={handleOpen} />
      {isOpen && (
        <CreateModal
          open={isOpen}
          prevForm={module}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Container>
  )
}

export default CreationPanel
